function ConditionGraphModalController(chartColorService, eventService, ConditionService, toasterService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.alert = angular.copy(ctrl.resolve.alert);
  };

  ctrl.selectAsset = event => {
    ctrl.selectedAsset = event.asset;
  };

  ctrl.onGraphVisible = event => {
    ctrl.chartVisible = event;
  };

  ctrl.goToPrevious = () => {
    if (ctrl.chartVisible) {
      ctrl.chartVisible = null;
    } else if (ctrl.selectedConfig) {
      ctrl.selectedConfig = null;
    } else {
      ctrl.selectedAsset = null;
    }
  };

  ctrl.save = () => {
    ctrl.close();
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };

  eventService.on('return-ci-list', function() {
    ctrl.goToPrevious();
  });

}

angular.module('modalDirectives').controller('ConditionGraphModalController', ConditionGraphModalController);
